import { AppStoreModule } from '../../app/store/module';
import I18nLocaleEnum from '../../i18n/locale.enum';

export default function isRTL(): boolean {
  return AppStoreModule.locale === I18nLocaleEnum.ar;
}
